import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import InputField from '../../../../reusable-components/InputField';
import CheckboxField from '../../../../reusable-components/CheckboxField';
import { required, number, positive, checked } from '../../../../utils/validations';
import { computeSize, normalizeNumber } from '../../../../utils/helpers';
import Header from '../../../../reusable-components/Header';
import Footer from '../../../../reusable-components/Footer';
import Body from '../../../../reusable-components/Body';
import Spinner from '../../../../reusable-components/Spinner';
import PageContent from '../../../../reusable-components/ActivatePageContent';
import PageHeader from '../../../../reusable-components/ActivatePageHeader';
import PropTypes from 'prop-types';
import { change } from 'redux-form';

class OptionOneForm extends Component {
  constructor(props){
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(values){
    const { updateObject, history } = this.props;
    updateObject(values, history);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.firstOptionFormValues !== prevProps.firstOptionFormValues) {
      try {
        const { object_length, object_width } = this.props.firstOptionFormValues;
        if (object_length && object_width) {
          computeSize('step-three-option-one', object_length, object_width, this.props);
        }
      } catch (err) {}
    }
  }

  render() {
    const { handleSubmit, pristine, submitting, isloading, formErrors, jetty_types } = this.props;

    let buttonState = isloading ? <Spinner /> : "Doorgaan";

    return (
      <React.Fragment>
        <PageHeader title="Bevestig informatie" />
        <PageContent 
          title="Woonboot informatie"
          goBack={() => this.props.history.goBack()}
          moveNext={() => {}}
          cardClass="card-container"
          showFooter={true}
          hasSubmitBtn={true}
          hasBackBtn={true}
          formClassNames=""
          buttonState={isloading}
          submitting={submitting}
          btnDisabled={pristine || submitting}
          handleSubmit={handleSubmit(this.onSubmit)}>
        <div className="form-container medium-container">
          <div className="form-row">
            <div className="form-group col-sm-6 col-md-12">
              <Field
                type="text"
                name="object_name"
                label="Naam Boot"
                component={InputField}
                props={{formErrors: formErrors}}
              />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group col-sm-6 col-md-3">
              <Field
                required
                type="text"
                step="any"
                name="object_length"
                label="Lengte(m)"
                component={InputField}
                props={{formErrors: formErrors}}
                validate={[required]}
                normalize={normalizeNumber}
              />
            </div>
            <div className="form-group col-sm-6 col-md-3">
              <Field
                required
                type="text"
                name="object_width"
                label="Breedte(m)"
                step="any"
                component={InputField}
                props={{formErrors: formErrors}}
                validate={[required]}
                normalize={normalizeNumber}
              />
            </div>
            <div className="form-group col-sm-6 col-md-3">
              <Field
                required
                type="text"
                name="object_height"
                label="Hoogte(m)"
                step="any"
                component={InputField}
                props={{formErrors: formErrors}}
                validate={[required]}
                normalize={normalizeNumber}
              />
            </div>
            <div className="form-group col-sm-6 col-md-3">
              <Field
                required
                type="text"
                name="object_depth"
                label="Diepte(m)"
                step="any"
                component={InputField}
                props={{formErrors: formErrors}}
                validate={[required]}
                normalize={normalizeNumber}
              />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group col-sm-6 col-md-12">
              <Field
                type="text"
                name="object_size"
                label="Oppervlakte(m²)"
                component={InputField}
                props={{formErrors: formErrors}}
                disabled
              />
            </div>
          </div>
          <div className="form-row checkbox-margin-top">
            <div className="form-group col-md-12">
              <Field 
                name="agreement" 
                component={CheckboxField} 
                type="checkbox"
                validate={checked} 
                required
              />
            </div>
          </div>
          {/*<div className="content-footer">
            <button 
              type="button" 
              className="btn back-btn"
              onClick={() => {
                this.props.history.goBack();
              }}>
              Terug
            </button>
            <button type="submit" className="btn continue-btn" disabled={submitting}>
              {buttonState}
            </button>
          </div>*/}
        </div>
        </PageContent>
      </React.Fragment>
    );
  }
}

OptionOneForm.propTypes = {
  isloading: PropTypes.bool,
  initialValues: PropTypes.object,
  formErrors: PropTypes.object
}

const FirstOptionComponent = reduxForm({
  form: 'step-three-option-one',
  enableReinitialize: true
})(OptionOneForm);

export default FirstOptionComponent;

